// @flow

import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "./grid-theme.scss";

export type GridProps = {
  columnDefs: Array<{
    // https://www.ag-grid.com/javascript-data-grid/column-properties/
    headerName?: string,
    headerTooltip?: string,
    headerClass?: string | string[],
    field?: string,
    suppressAutoSize?: boolean,

    suppressSizeToFit?: boolean,
    resizable?: boolean,
    colId?: string,
    type?: string | string[],
    valueGetter?: string | Function,
    valueFormatter?: string | Function,
    refData?: { [key: string]: string },
    keyCreator?: Function,
    equals?: Function,
    checkboxSelection?: boolean,
    showDisabledCheckboxes?: boolean,
    suppressColumnsToolPanel?: boolean,
    columnGroupShow?: string,
    icons?: { [key: string]: Function | string },
    suppressNavigable?: boolean | Function,
    suppressKeyboardEvent?: Function,
    suppressPaste?: boolean,
    suppressFillHandle?: boolean,
  }>,
  rowData: *,
  width?: number | string,
  height?: number,
  maxHeight?: number,
  autoSizeToFit?: boolean,
  autoSizeColumns?: boolean,
  autoSizeColumnsWithoutHeaders?: boolean,
  title?: string,
  titleClass?: string,
  defaultColDef?: Object,
};

class AgGrid extends Component<GridProps> {
  gridApi: *;
  gridColumnApi: *;

  sizeColumnsToFit = (params: Object) => {
    this.gridApi.sizeColumnsToFit();
  };

  onFirstDataRendered = (params: Object) => {
    this.gridApi = params.api;
    if (this.props.autoSizeToFit !== false) {
      this.sizeColumnsToFit(params);
      window.addEventListener("resize", () => {
        this.sizeColumnsToFit(params);
      });
    }
  };

  get defaultColDef() {
    return {};
  }

  get rowData() {
    return this.props.rowData || [];
  }

  get gridHeight() {
    // 70px header heioght + horizontal scrollbar height
    // 550 because we want 600px to be maxHeight so 50+550=600
    // 13 * 40 (the row height) is closest num to 550
    //  ... the rest are simple calculations
    return (
      70 + //
      (this.rowData.length > 13 ? (this.props.height || 600) - 51 : this.rowData.length * 40) +
      "px"
    );
  }

  render() {
    return (
      <div
        className="ag-theme-balham"
        style={{
          height: this.props.height || this.gridHeight,
          width: this.props.width || "100%",
        }}
      >
        {this.rowData.length ? (
          <AgGridReact
            rowHeight={40}
            headerHeight={50}
            rowData={this.rowData}
            defaultColDef={this.defaultColDef}
            columnDefs={this.props.columnDefs}
            onFirstDataRendered={this.onFirstDataRendered}
            alwaysShowHorizontalScroll={true}
            suppressMenuHide={true}
            {...this.props}
          />
        ) : (
          <div className="w-100 text-center">No data</div>
        )}
      </div>
    );
  }
}

export default AgGrid;
